import { render, staticRenderFns } from "./teacherTests.vue?vue&type=template&id=33d2eb16&scoped=true"
import script from "./teacherTests.vue?vue&type=script&lang=js"
export * from "./teacherTests.vue?vue&type=script&lang=js"
import style0 from "./teacherTests.vue?vue&type=style&index=0&id=33d2eb16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d2eb16",
  null
  
)

export default component.exports